import { NgModule } from '@angular/core';
import { CommonModule } from 'app/common.module';

import { LogoutModalModule } from 'app/components/logout-modal/logout-modal.module';

import { SidebarNavModule } from 'shared/components/sidebar-nav/sidebar-nav.module';

import { SidenavBarModule } from 'app/components/app-common-views/sidebar-nav/sidenav-bar.module';

import { HeaderModule } from 'app/components/app-common-views/header/header.module';
import { HeaderProcessingActionsComponent } from 'app/components/app-common-views/nav-container/header-processing-actions/header-processing-actions.component';
import { NavContainerComponent } from 'app/components/app-common-views/nav-container/nav-container.component';
import { ProcessingActionsDisplayOnlyComponent } from 'app/components/app-common-views/nav-container/processing-actions-display-only/processing-actions-display-only.component';
import { ProcessingActionsLeftComponent } from 'app/components/app-common-views/nav-container/processing-actions-left/processing-actions-left.component';
import { ProcessingActionsRightComponent } from 'app/components/app-common-views/nav-container/processing-actions-right/processing-actions-right.component';
import { ProcessingActionsComponent } from 'app/components/app-common-views/nav-container/processing-actions/processing-actions.component';
import { ViewBodyComponent } from 'app/components/app-common-views/nav-container/view-body/view-body.component';
import { ViewFooterComponent } from 'app/components/app-common-views/nav-container/view-footer/view-footer.component';
import { ErrorPanelModule } from 'shared/components/error-panel/error-panel.module';
import { LoadingSpinnerModule } from 'shared/components/loading-spinner/loading-spinner.module';
import { RetryToastContentModule } from 'shared/components/retry-toast-content/retry-toast-content.module';
import { ViewHeaderComponent } from 'app/components/app-common-views/nav-container/view-header/view-header.component';

@NgModule({
  imports: [
    CommonModule,
    HeaderModule,
    LogoutModalModule,
    SidebarNavModule,
    SidenavBarModule,
    LoadingSpinnerModule,
    RetryToastContentModule,
    ErrorPanelModule,
  ],
  exports: [
    NavContainerComponent,
    ViewBodyComponent,
    HeaderProcessingActionsComponent,
    ProcessingActionsLeftComponent,
    ProcessingActionsDisplayOnlyComponent,
    ProcessingActionsRightComponent,
    ProcessingActionsComponent,
    ViewFooterComponent,
    ViewHeaderComponent,
  ],
  declarations: [
    NavContainerComponent,
    ViewBodyComponent,
    HeaderProcessingActionsComponent,
    ProcessingActionsLeftComponent,
    ProcessingActionsDisplayOnlyComponent,
    ProcessingActionsRightComponent,
    ProcessingActionsComponent,
    ViewFooterComponent,
    ViewHeaderComponent,
  ],
  providers: [],
})
export class NavContainerModule {}
